import PropTypes from 'prop-types';
import { TextInput, ReferenceInput, maxLength, AutocompleteInput, useTranslate } from 'react-admin';
import FormDialog from '@/components/global/drawers/FormDialog.jsx';
import { groupFilterToQuery } from '@/helpers/filters/filterToQuery';

export const DeviceBulkForm = ({ isAdmin }) => {
    const translate = useTranslate();
    return (
        <FormDialog key='FormDialog' title={translate('common.update')}>
            {isAdmin && (
                <ReferenceInput key='groupId' source='groupId' reference='device-group' queryOptions={{ meta: { queryField: 'q' } }}>
                    <AutocompleteInput fullWidth filterToQuery={groupFilterToQuery} label={translate('resources.device.labels.searchByGroup')} />
                </ReferenceInput>
            )}
            <TextInput
                key='description'
                source='description'
                label={translate('common.description')}
                fullWidth={true}
                multiline
                validate={maxLength(500, translate('common.validation.maxLength', { count: 500 }))}
            />
        </FormDialog>
    );
};

DeviceBulkForm.propTypes = {
    isAdmin: PropTypes.bool,
};
